<template>
    <div class="profile-modal">
        <div class="main-header__user-info">
            <div v-if="activeMenu === 'main'" class="user-info__details">
                <span class="user-info__username">
                    {{ currentUser.full_name }}
                </span>

                <span class="user-info__role">{{ currentUser.is_admin ? 'Администратор' : currentUser.dealer_name }}</span>
            </div>

            <HeaderMainSettings
                v-if="activeMenu === 'main'"
                @change-dealer="activeMenu = 'change-dealer'"
            />

            <HeaderChangeDealerSettings
                v-if="activeMenu === 'change-dealer'"
                class="user-info__settings-menu--change-dealer"
                @main="activeMenu = 'main'"
            />
        </div>
    </div>
</template>

<script lang="ts" setup>
    import { ref } from 'vue';
    import { injectStrict } from '@/injection/injectStrict';
    import { AuthKey } from '@/injection/keys';

    import { CurrentUser } from '@/types/user/users.type.ts';

    import HeaderChangeDealerSettings from '@/layouts/MainLayout/components/HeaderChangeDealerSettings/HeaderChangeDealerSettings.vue';
    import HeaderMainSettings from '@/layouts/MainLayout/components/HeaderMainSettings/HeaderMainSettings.vue';

    const $Auth = injectStrict(AuthKey);

    const activeMenu = ref<string>('main');

    const currentUser: CurrentUser = $Auth.getCurrentUser();
</script>

<style scoped lang="scss">
    @use 'ProfileModal' as *;
</style>
